<template>
    <svg version="1.1" id="Layer_1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="22px" height="20px" viewBox="0 0 22 20"
         style="enable-background:new 0 0 22 20;"
         xml:space="preserve">
															<path class="st0" fill="#FFFFFF"
                                                                  d="M10.691,6.482c0,0-2.191,0.174-5.215-1.321C2.45,3.666,1.374,1.79,1.374,1.79s-1.947,3.582,1.391,6.013 C1.705,8.007,0.81,7.212,0.81,7.212s-0.721,3.093,3.413,4.64c-0.988,0.364-1.927,0-1.927,0s0.365,2.763,4.136,3.128 C5.11,16.39,2.764,17.068,0,16.895c1.479,1.702,5.251,2.133,6.918,2.069c6.205-0.244,12.775-4.313,12.775-13.49 c0,0,1.683-1.111,2.307-2.411c-0.881,0.512-2.504,0.719-2.504,0.719s1.623-1.113,1.83-2.572c-1.134,0.81-2.804,1.181-2.804,1.181 S17.271,0.93,15,1.002C12.73,1.071,10.018,2.947,10.691,6.482"/>
														</svg>
</template>

<script>
    export default {}
</script>